<div class="mt-5 text-center">
  <img ngSrc="assets/images/error-404.svg" alt="Error" height="120" width="auto">
  <h3 class="mt-3 mb-2">Página no encontrada</h3>
  <p class="text-muted mb-3">La página que buscas no existe, por favor revisa que has introducido una url correcta.</p>
</div>
